import { buildSchema, buildProperty, EntityOnSaveProps, buildEntityCallbacks, } from "@camberi/firecms";


export const usersSchema = buildSchema({
    name: "User",
    properties: {
        firstName: {
            title: "firstName",
            dataType: "string",
            validation: {
                required: true
            }
        },
        lastName: {
            title: "lastName",
            dataType: "string"
        },
        email: {
            title: "Email",
            dataType: "string",
            validation: {
                email: true
            }
        },
        isCoach: {
            title: "isCoach",
            dataType: "boolean",
        },
        isSubscribed: {
            title: "iSubscribed",
            dataType: "boolean",
            disabled: {
                hidden: true
            }
        },
        photoURL: buildProperty({
            title: "PHOTO URL",
            dataType: "string",
            description: "Recommended size (200 X 140)",
            config: {
                storageMeta: {
                    mediaType: "image",
                    storeUrl: true,
                    storagePath: "images",
                    acceptedFiles: ["image/*"],
                    metadata: {
                        cacheControl: "max-age=1000000"
                    },
                    fileName: (context) => {
                        return Math.random() + "-" + context.file.name;
                    }
                }
            }
        }),
        address: {
            title: "address",
            dataType: "string"
        },
        currentHeight: {
            title: "currentHeight",
            dataType: "number"
        },
        heightUnit: buildProperty({
            title: "Height Unit",
            validation: { required: true },
            dataType: "string",
            columnWidth: 140,
            config: {
                enumValues: {
                    cm: "CM",
                    ft: "FT"
                }
            },
        }),
        currentWeight: {
            title: "currentWeight",
            dataType: "number"
        },
        weightUnit: buildProperty({
            title: "Weight Unit",
            validation: { required: true },
            dataType: "string",
            columnWidth: 140,
            config: {
                enumValues: {
                    kg: "KG",
                    lb: "LB"
                }
            },
        }),
        dateOfBirth: {
            title: "dateOfBirth",
            dataType: "string"
        },
        gender: buildProperty({
            title: "Gender",
            validation: { required: true },
            dataType: "string",
            columnWidth: 140,
            config: {
                enumValues: {
                    male: "Male",
                    female: "Female",
                    rather_not_say: "Rather Not Say",
                    unknown: "Unknown",
                }
            },
        }),
        isArchived: {
            title: "isArchived",
            dataType: "boolean"
        },
        phoneNumber: {
            title: "phoneNumber",
            dataType: "string"
        },
        subscription: {
            title: "Subscription",
            dataType: "number"
        },
        subscriptionEndsAt: {
            title: "subscriptionEndsAt",
            dataType: "string"
        },
        timezone: {
            title: "timezone",
            dataType: "string"
        },
        userType: {
            title: "userType",
            dataType: "number"
        },
        createdAt: {
            title: "createdAt",
            dataType: "timestamp"
        },
        createdBy: {
            title: "createdBy",
            dataType: "string"
        },
        updatedAt: {
            title: "updatedAt",
            dataType: "string"
        },
        updatedBy: {
            title: "updatedBy",
            dataType: "string"
        },
        userGroup: buildProperty({
            title: "User Group",
            validation: { required: true },
            dataType: "number",
            columnWidth: 140,
            config: {
                enumValues: {
                    1: "Live",
                    0: "Test",
                }
            },
        }),
    },
    defaultValues: {
        userGroup: 1,
        isCoach: false
    }
});

export const attendeesSchema = buildSchema({
    name: "Users",
    properties: {
        name: {
            title: "name",
            dataType: "string",
            validation: {
                required: true
            }
        },
        hr: {
            title: "Heart Rate",
            dataType: "string",
            validation: {
                required: true
            }
        },
        calorie: {
            title: "calorie",
            dataType: "string",
            validation: {
                required: true
            }
        },
        createdAt: {
            title: "End Date",
            dataType: "timestamp",
            columnWidth: 250,
        },
    }
});

type PurchasedOneToOneSession = {
    quantity: number;
    createdAt: any;
    currency: string;
    rc_fee: string;
    createdBy: string;
    createdByUser: any;
}

export const purchasedOneToOneSessionSchema = buildSchema<PurchasedOneToOneSession>({
    name: "One To One Credits",
    properties: {
        quantity: {
            title: "Quantity",
            dataType: "number",
            validation: { required: true },
        },
        createdAt: {
            title: "Created Date",
            dataType: "timestamp",
            columnWidth: 250,
            disabled: true,
            readOnly: true
        },
        currency: {
            title: "Currency",
            dataType: "string",
            columnWidth: 150,
            disabled: true,
            readOnly: true
        },
        rc_fee: {
            title: "Application Fee",
            dataType: "string",
            columnWidth: 150,
            disabled: true,
            readOnly: true
        },
        createdBy: {
            title: "Created By Id",
            dataType: "string",
            disabled: true,
            readOnly: true
        },
        createdByUser: buildProperty({
            title: "Created By",
            dataType: "reference",
            path: "users",
            previewProperties: ["firstName", "lastName", "isApproved"],
            disabled: true,
            readOnly: true
        }),
    }
});

export const purchasedOneToOneSessionCallbacks = buildEntityCallbacks<PurchasedOneToOneSession>({
    onPreSave: ({
        schema,
        path,
        entityId,
        values,
        status,
        context
    }) => {
        values.createdBy = context.authController.user.uid.toString();
        return values;
    },
    onSaveSuccess: (props: EntityOnSaveProps<PurchasedOneToOneSession>) => {
        console.log("onSaveSuccess", props);
    },

    onSaveFailure: (props: EntityOnSaveProps<PurchasedOneToOneSession>) => {
        console.log("onSaveFailure", props);
    },
});
